import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
} from "@mui/material";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Colors } from "../../constants/Colors";
import { apiRequest } from "../../services/api-request";
import { useAppContext } from "../../context/AppContext";
import SelectPicker from "../../components/SelectPicker";

const Add = (props) => {
  
  const { isEdit, currentList } = props;

  const { user } = useAppContext();

  const [circleList, setCircleList] = useState({
    data: [],
    loader: false,
  });

  const [regionalList, setRegionalList] = useState({
    data: [],
    loader: false,
  });

  const schema = yup
    .object({
      name: yup.string().required("Name is required"),
      code: yup.string().required("Code is required"),
      selectCircle: yup.string().required("Circle office is required"),
      selectRegional: yup.string().required("Regional office is required"),
    })
    .required();

  const getEditUserDetails = (isEdit, currentList) => {
    if (!isEdit) {
      return { name: "", selectCircle: "", selectRegional: ""};
    } else {
      return {
        name: currentList?.name,
        code: currentList?.code,
        selectCircle: currentList?.circle_id,
        selectRegional: currentList?.regional_id,
      };
    }
  };

  const { handleSubmit, control,  getValues, watch } = useForm({
    resolver: yupResolver(schema),
    defaultValues: getEditUserDetails(isEdit, currentList),
  });

  useEffect(() => {
    getCirlces();
  }, []);

  const getCirlces = () => {
    apiRequest({
      url: "master/get-circle-office",
      method: "GET",
    })
      .then((res) => {
          const getList = res?.data?.map((elem) => ({
            name: elem?.name,
            value: elem?.id,
          }));
          setCircleList({ data: getList, loader: false });
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
    if (watch("selectCircle")) {
      getRegionals(watch("selectCircle"));
    }
  }, [watch("selectCircle")]);

  const getRegionals = (circle_id) => {
    apiRequest({
      url: "master/get-regional-office?circle_id="+circle_id,
      method: "GET",
    })
      .then((res) => {
        const getList = res?.data?.map((elem) => ({
            name: elem?.name,
            value: elem?.id,
          }));
          setRegionalList({ data: getList, loader: false });
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  const onSubmit = (data) => {
    if (isEdit && currentList?.name) {
      const payload = {
        name: data?.name,
        code: data?.code,
        circle_id: data?.selectCircle,
        regional_id: data?.selectRegional,
        id: currentList?.id,
      };
      apiRequest({
        url: `master/add-update-branch`,
        data: payload,
        method: "POST",
      })
        .then((res) => {
          props.onClickModalClose(true);
          props.getLists()
          if (res?.success === true) {
            alert("Branch updated successfully");
          }
          if (res?.success === false) {
            alert(res?.message);
          }
        })
        .catch((err) => {
          alert(err?.response?.data?.message, "error");
        });
    } else {
      const payload = {
        name: data.name,
        code: data.code,
        circle_id: data.selectCircle,
        regional_id: data.selectRegional,
      };
      apiRequest({
        url: `master/add-update-branch`,
        data: payload,
        method: "POST",
      })
        .then((res) => {
          props.onClickModalClose(true);
          props.getLists()
          if (res?.success === true) {
            alert("Branch added successfully");
          }
          if (res?.success === false) {
            alert(res?.message);
          }
        })
        .catch((err) => {
          console.log(err);
          alert(err?.response?.data?.message, "error");
        });
    }
  };

  return (
    <>
      {props.loader ? (
        <>{"loading"}</>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}
            mt={"10px"}
            gap={3}>

            <Grid item width="45%">
              <Controller
                name="name"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CustomInput
                    {...field}
                    type={"text"}
                    inputLabel={"Enter Branch Name"}
                    error={!!error}
                    helperText={error ? error.message : ""}
                  />
                )}
              />
            </Grid>

            <Grid item width="45%">
              <Controller
                name="code"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CustomInput
                    {...field}
                    type={"text"}
                    inputLabel={"Enter Branch Code"}
                    error={!!error}
                    helperText={error ? error.message : ""}
                  />
                )}
              />
            </Grid>

            <Grid item width="45%">
              <Controller
                name="selectCircle"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <SelectPicker
                    {...field}
                    borderRadius={10}
                    width={300}
                    options={circleList.data}
                    placeholder={"Select Circle Office"}
                    error={!!error}
                    helperText={error ? error?.message : ""}
                  />
                )}
              />
            </Grid>

            <Grid item width="45%">
              <Controller
                name="selectRegional"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <SelectPicker
                    {...field}
                    borderRadius={10}
                    width={300}
                    options={regionalList.data}
                    placeholder={"Select Regional Office"}
                    error={!!error}
                    helperText={error ? error?.message : ""}
                  />
                )}
              />
            </Grid>

          </Grid>
          <Grid
            container
            alignItems={"flex-start"}
            justifyContent="center"
            mt={3}
            width={"100%"}
            gap={3}>
            <Grid item width={"45%"}>
              <Box
                display={"flex"}
                alignItems={"end"}
                justifyContent={"flex-end"}
                width={"100%"}
                gap={"12px"}>
                <Box width={"48%"}>
                  <CustomButton
                    variant={"outlined"}
                    title={`Cancel`}
                    handleButtonClick={props.onClickModalClose}
                    backgroundColor={Colors.white}
                    textColor={Colors.headerColor}
                    width={"100%"}
                    height={34}
                    borderColor={Colors.headerColor}
                    textFontSize={14}
                  />
                </Box>
                <Box width={"48%"}>
                  <CustomButton
                    title={`Save`}
                    backgroundColor={Colors.headerColor}
                    textColor={Colors.white}
                    width={"100%"}
                    height={34}
                    borderColor={Colors.headerColor}
                    textFontSize={14}
                    type={"submit"}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};

export default Add;
